// extracted by mini-css-extract-plugin
export var copyableField = "_p5-4";
export var customerBadge = "_p5-0";
export var customerInfoTitle = "_p5-2";
export var details = "_p5-1";
export var dropdownContainer = "_p5-5";
export var dropdownImage = "_p5-6";
export var editAssigneeForm = "_p5-a";
export var editButton = "_p5-3";
export var email = "_p5-7";
export var hidden = "_p5-d";
export var input = "_p5-8";
export var saveButton = "_p5-b";
export var shopifyIcon = "_p5-c";
export var suggestionBadge = "_p5-e";
export var suggestionText = "_p5-f";
export var username = "_p5-9";